import React, { useEffect, useState } from 'react';
import AuthForm from './AuthForm';
import ThemeToggleButton from './ThemeToggleButton';
import { SERVER_URL } from '../services/authService';
import './WelcomePage.css';

const features = [
  'Спреды между акциями и фьючерсами в реальном времени',
  'Расчет доходности каждой сделки на вход и выход',
  'Одновременные заявки по двум активам',
  'Автоматизированный вход и выход с помощью робота',
  'Математическая гарантия безрисковой доходности'
];

const METRICS = [
  { key: 'totalDealsCount', label: 'сделок проведено', digits: 0, suffix: ' шт.' },
  { key: 'totalProfit', label: 'принесли прибыли', digits: 0, suffix: ' ₽' },
  { key: 'totalInManagement', label: 'находится под управлением', digits: 0, suffix: ' ₽' }
];

const PLACEHOLDER = '∞';

const formatMetricValue = (value, digits = 0, suffix = '') => {
  if (value == null || Number.isNaN(Number(value))) {
    return PLACEHOLDER;
  }
  return `${Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })}${suffix}`;
};

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <circle cx="9" cy="9" r="9" fill="rgba(139, 92, 246, 0.18)" />
    <path
      d="M5.5 9.2L7.8 11.5L12.5 6.8"
      stroke="#a78bfa"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WelcomePage = ({ onLogin, onRegister }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadStats = async () => {
      try {
        const response = await fetch(`${SERVER_URL}/v1/deals/stats`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        if (!cancelled) {
          setStats(data);
        }
      } catch {
        // оставляем плейсхолдеры при ошибке сети
      }
    };

    loadStats();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="welcome-page">
      <ThemeToggleButton className="welcome-theme-toggle" />
      <div className="welcome-grid">
        <section className="welcome-hero" aria-labelledby="welcome-title">
          <div className="welcome-brand">
            <span className="welcome-brand-mark" aria-hidden="true" />
            Exponenta
          </div>

          <h1 id="welcome-title">Арбитражные сделки на MOEX</h1>
          <p className="welcome-lead">
            Платформа для автоматизации арбитражных сделок на Московской бирже
          </p>

          <ul className="welcome-features">
            {features.map((feature) => (
              <li key={feature}>
                <CheckIcon />
                <span>{feature}</span>
              </li>
            ))}
          </ul>

          <div className="welcome-metrics" aria-label="Статистика платформы">
            {METRICS.map(({ key, label, digits, suffix }) => (
              <div className="welcome-metric" key={key}>
                <span className="welcome-metric-value">
                  {stats ? formatMetricValue(stats[key], digits, suffix) : PLACEHOLDER}
                </span>
                <span className="welcome-metric-label">{label}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="welcome-auth" aria-label="Авторизация">
          <div className="welcome-auth-panel">
            <AuthForm onLogin={onLogin} onRegister={onRegister} variant="panel" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default WelcomePage;
